"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./CancelStyles.scss");
const RefundTextComponent_1 = __importDefault(require("../../components/refundTextComponent/RefundTextComponent"));
const Cancel = () => {
    return (react_1.default.createElement("div", { className: "Cancel" },
        react_1.default.createElement("p", null,
            react_1.default.createElement("span", null,
                react_1.default.createElement(RefundTextComponent_1.default, null)))));
};
exports.default = Cancel;
